import type { JsonDataItem } from '@myosh/odin-components';
import { Button, IconButton } from '@myosh/odin-components';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface LinkedRecordsActionsCellProps {
  rowData: JsonDataItem;
  removeLinkedRecord: (rowId: string) => void;
  moveOptionUp?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, rowIndex: number) => void;
  moveOptionDown?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, rowIndex: number) => void;
  numberOfRows?: number;
  isTextualQuestionnaireLinkedRecords?: boolean;
}

const LinkedRecordsActionsCell = ({
  rowData,
  removeLinkedRecord,
  moveOptionUp,
  moveOptionDown,
  numberOfRows,
  isTextualQuestionnaireLinkedRecords,
}: LinkedRecordsActionsCellProps) => {
  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    removeLinkedRecord(String(rowData.id));
  };

  const onClickMoveUp = useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>, rowIndex: number) => {
    moveOptionUp?.(event, rowIndex);
  }, []);

  const onClickMoveDown = useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>, rowIndex: number) => {
    moveOptionDown?.(event, rowIndex);
  }, []);

  return (
    // NOTE: if modifying the padding 'pl-2', please remember to update all other cells
    <div className="flex h-full items-center justify-center py-1 pl-2">
      {moveOptionUp && !isTextualQuestionnaireLinkedRecords && (
        <IconButton
          icon="ChevronUp"
          iconClassName="text-primary-1"
          onClick={(e) => onClickMoveUp(e, rowData.rowIndex as number)}
          disabled={rowData.rowIndex === 0}
          classNames="hover:bg-primary-5"
        />
      )}
      {moveOptionDown && !isTextualQuestionnaireLinkedRecords && (
        <IconButton
          icon="ChevronDown"
          iconClassName="text-primary-1"
          onClick={(e) => onClickMoveDown(e, rowData.rowIndex as number)}
          disabled={numberOfRows === (rowData.rowIndex as number) + 1}
          classNames="hover:bg-primary-5"
        />
      )}
      <Button type="text" onClick={handleClick} classNames="hover:bg-primary-5">
        {t('remove')}
      </Button>
    </div>
  );
};

export default LinkedRecordsActionsCell;
